import service from './request'

export default {
  //搜索检索
  getSearch(text) {
    return service.get(`/tstd/search/?kw=${text}`)
  },

  //首页--------------------------------------------------
  //获取轮播图图片
  getSwipe() {
    return service.get('/tstd/carousel/')
  },
  //获取首页基本信息
  getBase() {
    return service.get('/tstd/base/')
  },
  //------------------------------------------------------

  //新闻中心================================================
  //获取新闻中心顶部图片
  getNewsImage() {
    return service.get('/tstd/image/news/')
  },
  //获取首页的新闻和行业资讯固定第一页的4个
  getNewsIndex() {
    return service.get('/tstd/news/?page_size=4&page=1')
  },
  getIndIndex() {
    return service.get('/tstd/ind/?page_size=4&page=1')
  },

  //----------------------------

  //获取新闻中心，page_size是一页存放的新闻数量，page是第几页
  getNews(count) {
    return service.get(`/tstd/news/?page_size=5&page=${count}`)
  },
  //获取一个新闻具体信息
  getNewsOne(id) {
    return service.get(`/tstd/detail/news/?id=${id}`)
  },
  //获取行业资讯，page_size是一页存放的数量，page 是第几页
  getInd(count) {
    return service.get(`/tstd/ind/?page_size=5&page=${count}`)
  },
  //获取行业资讯的具体一个
  getIndOne(id) {
    return service.get(`/tstd/detail/ind/?id=${id}`)
  },
  //==========================================================

  //关于我们~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
  //关于我们顶部图片
  getAbout() {
    return service.get('/tstd/image/about/')
  },
  //关于我们详情
  getAboutDetail() {
    return service.get('/tstd/about/')
  },
  //关于我们荣誉
  getHonor() {
    return service.get('/tstd/honor/')
  },
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

  //加入我们+++++++++++++++++++++++++++++++++++++++++++++++++++
  //加入我们顶部图片
  getJoin() {
    return service.get('/tstd/image/join/')
  },
  //欢迎致辞
  getWelcome() {
    return service.get('/tstd/welcome/')
  },
  //招聘岗位
  getJobs() {
    return service.get('/tstd/jobs/')
  },
  //++++++++++++++++++++++++++++++++++++++++++++++++++++++++++

  //产品与服务--------------------------------------------
  //一级分类
  getCategory() {
    return service.get('/tstd/category/')
  },
  //二级分类
  getSubCategory(id) {
    return service.get(`/tstd/sub_category/?category=${id}`)
  },
  //产品列表
  getCategoryList(id, is_category) {
    return service.get(`/tstd/products/?id=${id}&is_category=${is_category}`)
  },
  //具体产品信息
  getCategoryOne(id) {
    return service.get(`/tstd/detail/products/?id=${id}`)
  },
  //产品顶部图片
  getCategoryImage() {
    return service.get('/tstd/image/product/')
  },
  //---------------------------------------------------

  //联系我们==============================================
  //销售工程师
  getEngineer(count) {
    return service.get(`/tstd/sales/?page_size=4&page=${count}`)
  },
  //联系我们图片
  getContactImage() {
    return service.get('/tstd/image/contact/')
  },
  //在线留言
  //   getContact(name,phone,email,content) {
  //     return service.post({
  //         method:'post',
  //         url:'/tstd/message/',
  //         data: {
  //             name: name,
  //             phone:phone,
  //             email:email,
  //             content:content
  //         },
  //     })
  // return service.post('/tstd/message/?name=123&phone=1234&email=123@qq.com&content=哈哈')
  // },
  //   =======================================================

  //投资者关系！！！！！！！！！！！！！！！！！！！！！！！！！
  //投资者关系顶部图片
  getInvestorImage() {
    return service.get('/tstd/image/func/')
  },
  //市场信息，写死的图片
  //   getMarket() {
  //     return service.get(
  //       'http://quote.cfi.cn/DrawPrice.aspx?stockid=34589&type=day&w=540&h=400&round=0603160248007'
  //     )
  //   },
  //十大股东
  getInvestors() {
    return service.get('/tstd/shareholders/')
  },
  //财务信息 year中0表示年度1表示季度
  getFinance(i) {
    return service.get(`/tstd/profits/?year=${i}`)
  },
  //公司公告  0是临时 1是定期
  getNotice(id, index, year) {
    // /tstd/announcement/?types=${id}&year=${index}
    return service.get(
      `/tstd/announcement/?page=${index}&types=${id}&year=${year}`
    )
  },
  //投资者关系
  getRelation() {
    return service.get('/tstd/tzz/')
  },
  //！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！
}
